import { Types } from "@grandvisionhq/graphql";
const mapRegularLineItem = ({
  sku,
  quantity,
  typeDetails
}) => ({
  sku,
  quantity: quantity ?? 1,
  lineItemType: Types.LineItemType.REGULAR,
  typeDetails
});
export {
  mapRegularLineItem
};
//# sourceMappingURL=regular.js.map
